/**
 * 开启摄像头
 */
const startVideo = function(netcall,WebRTC){
    return netcall.startDevice({
        type: WebRTC.DEVICE_TYPE_VIDEO,
        width: 1200,
        height: 675,
    });
}
/**
 * 关闭摄像头
 */
const stopVideo = function(netcall,WebRTC) {
    return netcall.stopDevice(WebRTC.DEVICE_TYPE_VIDEO);
}
/**
 * 开启麦克风
 */
const startAudio = function(netcall,WebRTC) {
    return netcall.startDevice({
        type: WebRTC.DEVICE_TYPE_AUDIO_IN,
        enableEchoCancellation: true,//尝试消除回音
        device: {deviceId: ''}
    });
}
/**
 * 关闭麦克风
 */
const stopAudio = function(netcall,WebRTC) {
    return netcall.stopDevice(WebRTC.DEVICE_TYPE_AUDIO_IN);
}
/**
 * 发送自定义通知
 */
const sendCustomSysMsg = function(nim,accid,data){
    nim.sendCustomSysMsg({
        scene: 'p2p',
        to: accid,
        content: data,
        sendToOnlineUsersOnly: false,
        apnsText: JSON.stringify(data)
    });
}
/**
 * 离开房间
 */
const leaveChannel = function(netcall){
    netcall.leaveChannel().then(function(obj) {
        // 离开房间后，开发者自己业务的扫尾工作
    });
}

const broadcastRemoteVideo = function (netcall,account,divId,width,height){
    netcall.startRemoteStream({
        account: account,
        node: document.getElementById(divId)
    });
    // 设置对方预览画面大小
    netcall.setVideoViewRemoteSize({
        account: account,
        width: width,
        height: height,
        cut: false
    })
};
const broadcastLocalVideo = function (netcall,divId,width,height){
    netcall.startLocalStream(
        document.getElementById(divId)
    )
    // 设置本地预览画面大小
    netcall.setVideoViewSize({
        width: width,
        height: height,
        cut:true
    })
};
//开启屏幕共享
const startScreen = function(netcall,WebRTC){
    return netcall.startDevice({
        type: WebRTC.DEVICE_TYPE_DESKTOP_CHROME_SCREEN
    })
}
//按照屏幕的宽高获取当前视频需要的空间大小
const getWidthHeightByScreen = function(){
    let h = document.body.clientHeight;
    let w = document.body.clientWidth;
    let height,width,videoHeight,videoWidth,miniWidth,miniHeight;
    if(h/w>0.6){
        let tempWidth = w-121;
        videoWidth = tempWidth/18.7*16;
        videoHeight = videoWidth*9/16;
        miniHeight = (videoHeight-15)/6;
        miniWidth = miniHeight/9*16;
        height = videoHeight+102;
        width = tempWidth+20;
    }else{
        height = h*0.9;//内容框总高度
        videoHeight = height-42-60;//视频块儿的高度为总高度减去头部按钮区域底部按钮区高度
        videoWidth = videoHeight/0.5626;
        miniHeight  = (videoHeight - 15)/6;
        miniWidth = miniHeight/0.5626;
        width = videoWidth+miniWidth+20;
    }
    //距离顶部的距离
   // let top = height*0.1 - 41 - 50 -20;
    //91 顶部41+50
    //底部 60高

    return{
        height,
        videoHeight,
        videoWidth,
        miniHeight,
        miniWidth,
        width,
    }
}
export default {
    startVideo,
    stopVideo,
    startAudio,
    stopAudio,
    sendCustomSysMsg,
    leaveChannel,
    broadcastRemoteVideo,
    broadcastLocalVideo,
    getWidthHeightByScreen,
    startScreen,
}